import {UserAuthenticationBaseRequestDto, UserAuthenticationBaseResponseDto} from '../user-authentication-base.dto';
import {AutoMap} from '@automapper/classes';

export class GetVerificationCodeRequestDto extends UserAuthenticationBaseRequestDto {
  @AutoMap()
  public email!: string
}

export class GetVerificationCodeResponseDto {

}
